module.exports = __webpack_public_path__ + "static/CleverCloud-04ca782db0e48d4b648175aeaa213fb7.png";